import { Session } from 'smg/customer-api/session';
import * as taxexemptions from 'smg/customer-api/usertaxexemptions';
import * as models from 'smg/customer-api/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { DownloadURLs, Source } from 'smg/zip';
import { AccountReady } from '../account-session';
import { PageLoader } from '../account';
import { Draw, PromptNew } from '../usertaxexemptions';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const cardTemplate = document.querySelector('#card') as HTMLTemplateElement;
    const parent = document.querySelector('#taxExemptionsContainer') as HTMLElement;
    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');

    let user: models.User;

    const pl: PageLoader<models.HyejooUserTaxExemption> = new PageLoader<models.HyejooUserTaxExemption>({
        afterLoad: state => {
            if (state === 'failed') {
                return;
            }
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        init: async () => {
            user = await Session().then(s => s.user);
            addNewButton.forEach(el => {
                el.addEventListener('click', () => {
                    void PromptNew(user).then(() => {
                        pl.load();
                    });
                });
            });
        },
        parent: document.querySelector('#taxExemptionsContainer') as HTMLElement,
        get: () => taxexemptions.UserTaxExemptions({
            sort: pl.sort() ?? '',
            max: pl.currentPageSize(),
            p: pl.currentPage(),
            q: pl.search(),
        }).then(data => ({ rows: data.userTaxExemptions, nextPage: data.nextPage })),
        draw: async userTaxExemption => {
            const card = template.Clone(cardTemplate).firstElementChild as HTMLElement;
            const deleteBtn = card.querySelector<HTMLButtonElement>('.delete-btn');
            const downloadBtn = card.querySelector<HTMLButtonElement>('.download-btn');

            await Draw(userTaxExemption, card);

            deleteBtn?.addEventListener('click', () => {
                void taxexemptions.DeleteUserTaxExemption(userTaxExemption.id).
                    then(() => {
                        card.parentElement?.removeChild(card);
                        toast.Undo('Removed tax exemption.', async () => {
                            await taxexemptions.RestoreUserTaxExemption(userTaxExemption.id);
                            pl.load();
                        });
                        pl.load();
                    });
            });

            if (!userTaxExemption.userTaxExemptionUploads.length) {
                downloadBtn?.remove();
            }

            downloadBtn?.addEventListener('click', async () => {
                if (userTaxExemption.userTaxExemptionUploads.length) {
                    const urls: Source[] = [];

                    userTaxExemption.userTaxExemptionUploads.forEach(el => {
                        const url: Source = {
                            name: el.upload?.name ?? '',
                            url: el.upload ? el.upload.url() : '',
                        };

                        urls.push(url);
                    });

                    await DownloadURLs(userTaxExemption.number, urls);
                }
            });

            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.load();
}
